import { WorkflowStatus } from '@enview/interface/types/triage/WorkflowStatus';

// Joins names as "A", "A and B", or "A, B, and C".
const formatNameList = (names: string[]): string => {
  if (names.length <= 2) return names.join(' and ');
  return `${names.slice(0, -1).join(', ')}, and ${names[names.length - 1]}`;
};

type SingleBillStatusMessageParams = {
  status: WorkflowStatus;
  // Workspaces the bill was added to as part of the same action.
  addedWorkspaceNames?: string[];
  // True when the change takes the bill out of the What's New "New Bills" section.
  leftNewBillsQueue?: boolean;
};

export const singleBillStatusMessage = ({
  status,
  addedWorkspaceNames = [],
  leftNewBillsQueue = false,
}: SingleBillStatusMessageParams): string => {
  const addedClause = addedWorkspaceNames.length
    ? `, and added it to ${formatNameList(addedWorkspaceNames)}`
    : '';
  const queueSentence = leftNewBillsQueue
    ? " It's been removed from the New Bills queue."
    : '';
  return `You've set this bill status to ${status}${addedClause}.${queueSentence}`;
};

export const UNDO_SUCCEEDED_MESSAGE = 'Status change undone.';

export const UNDO_FAILED_MESSAGE = "We couldn't undo that status change.";

export const bulkStatusMessage = (billCount: number, status: WorkflowStatus): string =>
  `You've set the status of ${billCount} ${
    billCount === 1 ? 'bill' : 'bills'
  } to ${status}.`;
